import { render, staticRenderFns } from "./VProjects.vue?vue&type=template&id=05fb7a91&"
import script from "./VProjects.vue?vue&type=script&lang=js&"
export * from "./VProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports